// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2Rv7h","header":"PatientBlock_header__2PIa1","label":"PatientBlock_label__3qOdy","option":"PatientBlock_option__1Rjav"};